import { ExplicitContext, Instrumentation, Tracer } from 'zipkin';
import { DOTCOM_UX_ID } from '@nike/ux-tread-dotcom-constants';
import { getApiPathFromUrl } from '@nike/ux-tread-dotcom-utils';
var zipkinWrapper = function zipkinWrapper(url, options) {
  var _options, _options2;
  var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
    _ref$appName = _ref.appName,
    appName = _ref$appName === void 0 ? DOTCOM_UX_ID : _ref$appName;
  var builtTracer = new Tracer({
    ctxImpl: new ExplicitContext(),
    // We're using Explicit Context due to the zipkin issue: https://github.com/openzipkin/zipkin-js/issues/192
    // this is a no-op, required by zipkin lib but we don't need to send these logs anywhere
    recorder: {
      record: function record() {},
      toString: function toString() {}
    },
    localServiceName: appName // name of this application
  });

  var instrumentation = new Instrumentation.HttpClient({
    tracer: builtTracer,
    serviceName: appName,
    remoteServiceName: getApiPathFromUrl(url)
  });
  var zipkinOpts = instrumentation.recordRequest(options = (_options = options) !== null && _options !== void 0 ? _options : {}, url, ((_options2 = options) === null || _options2 === void 0 ? void 0 : _options2.method) || 'GET');
  return {
    tracer: builtTracer,
    options: zipkinOpts
  };
};
export default zipkinWrapper;